import { baseUrl } from "tbme/localState";
import { ProfileContext } from "../types";

export const setBaseUrlState = ({ communityUrl }: ProfileContext) => {
  if (!communityUrl) return;

  baseUrl(communityUrl);
};
